import React, { FC } from 'react';

import {
  Create,
  required,
  SimpleForm,
  TextInput,
} from 'react-admin';

import { useTitle } from '@src/hooks';

interface IConfigVersionCreateProps {
  label: string;
}

const ConfigVersionCreate: FC<IConfigVersionCreateProps> = ({ label }) => {
  const { title } = useTitle(`Create ${label}`);
  return (
    <Create redirect="list" title={title}>
      <SimpleForm>
        <TextInput
          label="Config version name"
          source="name"
          validate={[required()]}
        />
      </SimpleForm>
    </Create>
  );
};

export default ConfigVersionCreate;